import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { useLazyQuery } from '@apollo/client';
// import axios from 'axios';
// import { toast } from 'react-toastify';
import Googlemap from '../maps/maps';
import AutoSearch from '../auto-search/auto-search';
import ShippingProgressNoData from '../shipping-progress/shipping-progress-no-data/shipping-progress-no-data';
import {
  SEARCH_QUERY_PORT_TO_PORT,
  SEARCH_QUERY_AIRPORT_TO_AIRPORT,
  DOOR_ADDRESS,
  GET_GEOCODE,
  GET_NEW_GAUTOSUGGEST,
  GET_NEW_GEOCODE,
} from '../../graphQL/addAddress';
import BaiduMap from '../maps/baidumap';
import SearchSelect from '../search-select/search-select';
import useDebounce from '../../hooks/useDebounce';
import DragDropList from '../drag-and-drop/drag-and-drop';
import TextBoxGroup from '../text-box-group/text-box-group';
import './add-address.scss';
import { LocationOutlined } from '../icons/icons';

function AddAddress({
  Mode,
  TypeOfMove,
  origin,
  destination,
  setOrigin,
  setDestination,
  originOptions,
  setOrginOptions,
  destinationOptions,
  setDestinationOptions,
  originGeoCode,
  setOriginGeoCode,
  destinationGeoCode,
  setDestinationGeoCode,
  setOriginDoorAddress,
  setDestinationDoorAddress,
  setOriginCountry,
  setDestinationCountry,
  disable,
  disableOrigin,
  disableDestination,
  originLabel,
  destinationLabel,
  warehouseListOptions,
  setBookingVal,
  originLocation,
  destinationLocation,
  buyerEntityDetailsList,
  onStopsChange,
}) {
  const [t] = useTranslation('manageorders');
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [searchType, setSearchType] = useState(null);
  const debouncedSearchValue = useDebounce(searchText, 500);

  const [searchPort] = useLazyQuery(
    Mode.value === 'Ocean'
      ? SEARCH_QUERY_PORT_TO_PORT
      : SEARCH_QUERY_AIRPORT_TO_AIRPORT
  );
  const [searchDoor] = useLazyQuery(DOOR_ADDRESS);
  const [searchNewDoor] = useLazyQuery(GET_NEW_GAUTOSUGGEST);
  const [getDoorGeoCode] = useLazyQuery(GET_GEOCODE);
  const [getNewDoorGeoCode] = useLazyQuery(GET_NEW_GEOCODE);
  const [formData, setFormData] = useState([]);

  useEffect(() => {
    if (buyerEntityDetailsList?.length > 0) {
      setFormData(
        buyerEntityDetailsList.map((entity, index) => ({
          id: entity.entityId || index + 1,
          entityID: entity.entityId,
          entityName: entity.entityName || '',
          entityAddress: entity.entityAddress || '',
          address: entity.entityName || '',
        }))
      );
    }
  }, [buyerEntityDetailsList]);

  useEffect(() => {
    if (onStopsChange && formData.length > 0) {
      onStopsChange(
        formData.map((item, index) => ({
          entityID: item.entityID,
          entityName: item.entityName,
          entityAddress: item.entityAddress,
          sequenceID: index + 1,
        }))
      );
    }
  }, [formData]);

  const wrapperRef = useRef(null);
  const destinationRef = useRef(null);
  const [lineHeight, setLineHeight] = useState(0);

  const getGeoCode = (SearchParameter, type) => {
    if (Mode?.value !== 'Inland') {
      getDoorGeoCode({
        variables: { searchParameter: SearchParameter },
        onCompleted: (data) => {
          const geoCode = `${data.FetchGeoCode?.data[0].geometry.location.lat},${data.FetchGeoCode?.data[0].geometry.location.lng}`;

          if (type === 'origin') {
            setOriginGeoCode([{ GeoCoordinate: geoCode }]);
            setOriginDoorAddress(data.FetchGeoCode?.data[0].address_components);
          }
          if (type === 'destination') {
            setDestinationGeoCode([{ GeoCoordinate: geoCode }]);
            setDestinationDoorAddress(
              data.FetchGeoCode?.data[0].address_components
            );
          }
        },
      });
    } else {
      // new address format for Inland
      const optionsToFilter =
        type === 'origin' ? originOptions : destinationOptions;
      getNewDoorGeoCode({
        variables: {
          placeId: optionsToFilter?.find(
            (opt) => opt?.value === SearchParameter
          )?.place_id,
        },
        onCompleted: (data) => {
          const geoCode = `${data.FetchGeoCodeNewVersion?.data?.latitude},${data.FetchGeoCodeNewVersion?.data?.longitude}`;
          if (type === 'origin') {
            setOriginGeoCode([{ GeoCoordinate: geoCode }]);
            setOriginDoorAddress(data.FetchGeoCodeNewVersion?.data);
          }
          if (type === 'destination') {
            setDestinationGeoCode([{ GeoCoordinate: geoCode }]);
            setDestinationDoorAddress(data.FetchGeoCodeNewVersion?.data);
          }
        },
      });
    }
  };

  const serverCall = (type) => {
    setLoading(true);
    if (type === 'origin') {
      setOrginOptions([]);
    } else {
      setDestinationOptions([]);
    }

    // inland
    if (
      (type === 'origin' &&
        (TypeOfMove.value === 'door to door' ||
          TypeOfMove.value === 'door to port')) ||
      (type === 'destination' &&
        (TypeOfMove.value === 'door to door' ||
          TypeOfMove.value === 'port to door'))
    ) {
      if (Mode?.value !== 'Inland') {
        searchDoor({
          variables: {
            searchParameter: debouncedSearchValue,
          },
          onCompleted: (data) => {
            const option =
              data &&
              data.GAutoSuggest.data.map((item) => {
                return {
                  label: item.description,
                  value: item.description,
                };
              });
            if (type === 'origin') {
              setOrginOptions(option);
            } else {
              setDestinationOptions(option);
            }
            setLoading(false);
          },
          onError: () => {
            // toast.error(err.message);
            setLoading(false);
          },
        });
      } else {
        // new addresses for Inland
        searchNewDoor({
          variables: {
            searchParameter: debouncedSearchValue,
          },
          onCompleted: (data) => {
            const option =
              data &&
              data.GAutoSuggestNewVersion.data.map((item) => {
                return {
                  label: item?.formatted_address,
                  value: item?.formatted_address,
                  place_id: item?.place_id,
                };
              });
            if (type === 'origin') {
              setOrginOptions(option);
            } else {
              setDestinationOptions(option);
            }
            setLoading(false);
          },
          onError: () => {
            setLoading(false);
          },
        });
      }
    } else {
      // ocean / air
      searchPort({
        variables: {
          input: { SearchString: debouncedSearchValue },
        },
        onCompleted: (data) => {
          const option =
            Mode.value === 'Ocean'
              ? data.searchOceanPortDetails.data.map((dataMap) => {
                  return {
                    label: dataMap.OceanPortLongName,
                    value: dataMap.UNECECode,
                    GeoCoordinate: dataMap.GeoCoordinate,
                    CountryName: dataMap.CountryName,
                  };
                })
              : data.searchAirPortDetails.data.map((dataMap) => {
                  return {
                    label: dataMap.AirportLongName,
                    value: dataMap.AirportCodeIATA,
                    GeoCoordinate: dataMap.GeoCoordinate,
                    CountryName: dataMap.CountryName,
                  };
                });
          if (type === 'origin') {
            setOrginOptions(option);
          } else {
            setDestinationOptions(option);
          }
          setLoading(false);
        },
        onError: () => {
          // toast.error(err.message);
          setLoading(false);
        },
      });
    }
  };

  useEffect(() => {
    if (debouncedSearchValue && searchType) {
      serverCall(searchType);
    }
  }, [debouncedSearchValue]);

  const handleChange = (e, type) => {
    setSearchType(type);
    setSearchText(e.target.value);
  };

  const [state, setState] = useState({
    countryName: '',
  });

  useEffect(() => {
    setState({ countryName: '' });
    // getGeoInfo();
  }, []);
  useEffect(() => {
    setOrginOptions([]);
  }, []);

  useEffect(() => {
    const calculateLineHeight = () => {
      if (wrapperRef.current && destinationRef.current) {
        const wrapperRect = wrapperRef.current.getBoundingClientRect();

        const destinationRect = destinationRef.current.getBoundingClientRect();

        const height = destinationRect.top - wrapperRect.top;
        setLineHeight(height);
      }
    };

    calculateLineHeight();

    const resizeObserver = new ResizeObserver(() => {
      calculateLineHeight();
    });

    if (wrapperRef.current) {
      resizeObserver.observe(wrapperRef.current);
    }

    return () => {
      resizeObserver.disconnect();
    };
  }, [formData]);

  return (
    <div className="address-timeline-wrapper" ref={wrapperRef}>
      <div className="timeline-line" style={{ height: `${lineHeight}px` }} />

      {/* ================= ORIGIN ================= */}
      {!disableOrigin && (
        <>
          {/* Origin Location */}
          <div className="timeline-row">
            <div className="timeline-left">
              <span className="timeline-dot" />
            </div>

            <div className="timeline-right">
              {Mode?.value === 'Inland' && (
                <SearchSelect
                  data={warehouseListOptions}
                  onChange={(e) => {
                    setBookingVal('originLocation')({
                      label: e?.target?.value,
                      value: e?.target?.value?.toLowerCase(),
                    });
                  }}
                  label={t(
                    'manageordersscreen.createbookingmenu.shipmentdetails.originLocation'
                  )}
                  placeholder={t(
                    'manageordersscreen.createbookingmenu.shipmentdetails.enterOriginLocation'
                  )}
                  defaultValue={originLocation}
                  classNames="auto"
                  enableLabel
                  containerClassName="mb-20"
                  showFooterMessage={false}
                  enableRemove
                />
              )}

              {/* Origin Address */}

              <AutoSearch
                required
                id="originPort"
                label={originLabel}
                options={originOptions}
                disabled={disable}
                handleInputChanged={(e) => handleChange(e, 'origin')}
                removeSearchValue={() => {
                  setOrigin('');
                  setOrginOptions([]);
                  setOriginGeoCode('');
                }}
                placeholder={
                  TypeOfMove.value === 'door to door' ||
                  TypeOfMove.value === 'door to port'
                    ? t(
                        'manageordersscreen.createbookingmenu.addforwarder.pickupvendor.pickupaddressplc'
                      )
                    : t(
                        'manageordersscreen.createbookingmenu.shipmentdetails.originportplaceholder'
                      )
                }
                onChange={(e) => {
                  if (
                    (TypeOfMove.value === 'door to door' ||
                      TypeOfMove.value === 'door to port') &&
                    e?.target?.value !== ''
                  ) {
                    getGeoCode(e.target.value, 'origin');
                  } else {
                    setOriginGeoCode(
                      originOptions.filter(
                        (item) => item.value === e.target.value
                      )
                    );
                  }

                  if (originOptions && originOptions.length > 0) {
                    setOrigin(
                      originOptions.filter(
                        (item) => item.value === e.target.value
                      )[0]?.label
                    );

                    setOriginCountry(
                      originOptions.filter(
                        (item) => item.value === e.target.value
                      )[0]?.CountryName
                    );
                  }
                }}
                defaultValue={{ value: origin }}
                loading={loading}
              />

              <div className="map-box">
                {originGeoCode[0]?.GeoCoordinate !== 'NULL' ? (
                  <div>
                    {state.countryName !== 'China' ? (
                      <Googlemap
                        height="5.556vw"
                        width="100%"
                        latitude={
                          originGeoCode[0]?.GeoCoordinate
                            ? parseFloat(
                                originGeoCode[0]?.GeoCoordinate?.toString().split(
                                  ','
                                )[0]
                              )
                            : 18.0
                        }
                        long={
                          originGeoCode[0]?.GeoCoordinate
                            ? parseFloat(
                                originGeoCode[0]?.GeoCoordinate?.toString().split(
                                  ','
                                )[1]
                              )
                            : 72.556
                        }
                        className="address-map"
                      />
                    ) : (
                      <BaiduMap
                        mapHeight="8.333vw"
                        latitude={
                          originGeoCode[0]?.GeoCoordinate
                            ? parseFloat(
                                originGeoCode[0]?.GeoCoordinate?.toString().split(
                                  ','
                                )[0]
                              )
                            : 18.0
                        }
                        longitude={
                          originGeoCode[0]?.GeoCoordinate
                            ? parseFloat(
                                originGeoCode[0]?.GeoCoordinate?.toString().split(
                                  ','
                                )[1]
                              )
                            : 72.556
                        }
                      />
                    )}
                  </div>
                ) : (
                  <ShippingProgressNoData
                    message={
                      originGeoCode[0]?.GeoCoordinate !== 'NULL'
                        ? t(
                            'manageordersscreen.createbookingmenu.shipmentdetails.originMapPlaceholder'
                          )
                        : t(
                            'manageordersscreen.createbookingmenu.shipmentdetails.originNoDataText'
                          )
                    }
                    size="2.083vw"
                  />
                )}
              </div>
            </div>
          </div>
        </>
      )}

      {/* ================= STOPS ================= */}

      <DragDropList
        items={formData}
        style={{ height: '40px' }}
        onChange={setFormData}
        renderItem={({ item }) => (
          <div className="timeline-row stops-row">
            <TextBoxGroup
              id={`address-${item.id}`}
              type="text"
              value={item.address}
              onChange={() => {}}
              readOnly
              wraperClass="text-box-group-wrapper-blueborder"
              className="mb-0"
            />
          </div>
        )}
      />

      {/* ================= DESTINATION ================= */}

      {!disableDestination && (
        <>
          {/* Destination Location */}
          <div className="timeline-row">
            <div className="timeline-left" ref={destinationRef}>
              <span className="timeline-dot-location">
                <LocationOutlined color="#D2253B" size="0.972vw" />
              </span>
            </div>

            <div className="timeline-right">
              {Mode?.value === 'Inland' && (
                <SearchSelect
                  data={warehouseListOptions}
                  onChange={(e) => {
                    setBookingVal('destinationLocation')({
                      label: e?.target?.value,
                      value: e?.target?.value?.toLowerCase(),
                    });
                  }}
                  label={t(
                    'manageordersscreen.createbookingmenu.shipmentdetails.destinationLocation'
                  )}
                  placeholder={t(
                    'manageordersscreen.createbookingmenu.shipmentdetails.enterDestinationLocation'
                  )}
                  defaultValue={destinationLocation}
                  classNames="auto"
                  enableLabel
                  containerClassName="mb-20"
                  showFooterMessage={false}
                  enableRemove
                />
              )}

              {/* Destination Address */}

              <AutoSearch
                required
                id="destinationPort"
                label={destinationLabel}
                options={destinationOptions}
                handleInputChanged={(e) => handleChange(e, 'destination')}
                removeSearchValue={() => {
                  setDestination('');
                  setDestinationOptions([]);
                  setDestinationGeoCode('');
                }}
                disabled={disable}
                placeholder={
                  TypeOfMove.value === 'door to door' ||
                  TypeOfMove.value === 'port to door'
                    ? t(
                        'manageordersscreen.createbookingmenu.addforwarder.pickupvendor.pickupaddressplc'
                      )
                    : t(
                        'manageordersscreen.createbookingmenu.shipmentdetails.destinationportplaceholder'
                      )
                }
                onChange={(e) => {
                  if (
                    (TypeOfMove.value === 'door to door' ||
                      TypeOfMove.value === 'port to door') &&
                    e?.target?.value !== ''
                  ) {
                    getGeoCode(e.target.value, 'destination');
                  } else {
                    setDestinationGeoCode(
                      destinationOptions.filter(
                        (item) => item.value === e.target.value
                      )
                    );
                  }

                  if (destinationOptions && destinationOptions.length > 0) {
                    setDestination(
                      destinationOptions.filter(
                        (item) => item.value === e.target.value
                      )[0]?.label
                    );

                    setDestinationCountry(
                      destinationOptions.filter(
                        (item) => item.value === e.target.value
                      )[0]?.CountryName
                    );
                  }
                }}
                defaultValue={{ value: destination }}
                loading={loading}
              />

              <div className="map-box">
                {destinationGeoCode[0]?.GeoCoordinate !== 'NULL' ? (
                  <div>
                    {state.countryName !== 'China' ? (
                      <Googlemap
                        height="5.556vw"
                        width="100%"
                        latitude={
                          destinationGeoCode[0]?.GeoCoordinate
                            ? parseFloat(
                                destinationGeoCode[0].GeoCoordinate.toString().split(
                                  ','
                                )[0]
                              )
                            : 18.0
                        }
                        long={
                          destinationGeoCode[0]?.GeoCoordinate
                            ? parseFloat(
                                destinationGeoCode[0].GeoCoordinate.toString().split(
                                  ','
                                )[1]
                              )
                            : 72.55
                        }
                        className="address-map"
                      />
                    ) : (
                      <BaiduMap
                        mapHeight="8.333vw"
                        latitude={
                          destinationGeoCode[0]?.GeoCoordinate
                            ? parseFloat(
                                destinationGeoCode[0].GeoCoordinate.toString().split(
                                  ','
                                )[0]
                              )
                            : 18.0
                        }
                        longitude={
                          destinationGeoCode[0]?.GeoCoordinate
                            ? parseFloat(
                                destinationGeoCode[0].GeoCoordinate.toString().split(
                                  ','
                                )[1]
                              )
                            : 72.55
                        }
                      />
                    )}
                  </div>
                ) : (
                  <ShippingProgressNoData
                    message={
                      destinationGeoCode[0]?.GeoCoordinate !== 'NULL'
                        ? t(
                            'manageordersscreen.createbookingmenu.shipmentdetails.destinationMapPlaceholder'
                          )
                        : t(
                            'manageordersscreen.createbookingmenu.shipmentdetails.destinationNoDataText'
                          )
                    }
                    size="2.083vw"
                  />
                )}
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

AddAddress.propTypes = {
  Mode: PropTypes.instanceOf(Object),
  TypeOfMove: PropTypes.instanceOf(Object),
  setOrigin: PropTypes.func,
  setDestination: PropTypes.func,
  origin: PropTypes.string,
  destination: PropTypes.string,
  originOptions: PropTypes.instanceOf(Array),
  setOrginOptions: PropTypes.func,
  destinationOptions: PropTypes.instanceOf(Array),
  setDestinationOptions: PropTypes.func,
  originGeoCode: PropTypes.string,
  setOriginGeoCode: PropTypes.func,
  destinationGeoCode: PropTypes.string,
  setDestinationGeoCode: PropTypes.func,
  setOriginDoorAddress: PropTypes.instanceOf(Array),
  setDestinationDoorAddress: PropTypes.instanceOf(Array),
  setOriginCountry: PropTypes.func,
  setDestinationCountry: PropTypes.func,
  disable: PropTypes.bool,
  disableOrigin: PropTypes.bool,
  disableDestination: PropTypes.bool,
  originLabel: PropTypes.string,
  destinationLabel: PropTypes.string,
  warehouseListOptions: PropTypes.instanceOf(Array),
  setBookingVal: PropTypes.func,
  originLocation: PropTypes.string,
  destinationLocation: PropTypes.string,
  buyerEntityDetailsList: PropTypes.instanceOf(Array),
  onStopsChange: PropTypes.func,
};
AddAddress.defaultProps = {
  Mode: {},
  TypeOfMove: {},
  setOrigin: () => {},
  setDestination: () => {},
  origin: '',
  destination: '',
  originOptions: [],
  setOrginOptions: () => {},
  destinationOptions: [],
  setDestinationOptions: () => {},
  originGeoCode: '',
  setOriginGeoCode: () => {},
  destinationGeoCode: '',
  setDestinationGeoCode: () => {},
  setOriginDoorAddress: () => {},
  setDestinationDoorAddress: () => {},
  setOriginCountry: () => {},
  setDestinationCountry: () => {},
  disable: false,
  disableOrigin: false,
  disableDestination: false,
  originLabel: '',
  destinationLabel: '',
  warehouseListOptions: [],
  setBookingVal: () => {},
  originLocation: '',
  destinationLocation: '',
  buyerEntityDetailsList: [],
  onStopsChange: () => {},
};
export default AddAddress;
